module.exports = __webpack_public_path__ + "i18n/ru.fe6a30576bbb9849b93f1fe5330b780e.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/ru.json
// module id = 1863
// module chunks = 0